/* @flow strict */

import * as React from 'react';
import moment from 'moment';
import Switcher from '/client/src/components/switcher';
import { PUT } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { convertToLocalTime } from '/client/src/utils/jstz';
import { currency } from '/client/src/constants/';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

/* eslint-disable camelcase */

export const columns = (
  eventId: number | string,
  handleDiscountDisabled: (group_id: number, status: boolean) => void
): [] => {
  const EventDetailContext = React.useContext(EventDetailContainerContext);
  const context = React.useContext(DefaultContainerContext);

  return ([
    {
      selector: 'is_disabled',
      name: 'on/off',
      sortable: true,
      cell: (row: {}): React.Element<'div'> => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Switcher
            className='form-switcher-sm'
            id={row.group_id}
            name={row.group_id.toString()}
            index={row.group_id}
            checked={!row.is_disabled}
            onCallback={async (e: any, newStatus: boolean) => {
              CssPinner(document.querySelector('.EventDetailContainer .panel-body'), true);

              try {
                await PUT(`/api/v1/1/discounts/${eventId}/${row.group_id}/${newStatus ? 'enable' : 'disable'}`);
                handleDiscountDisabled(row.group_id, !newStatus);
                CssPinner(document.querySelector('.EventDetailContainer .panel-body'), false);
              } catch (error) {
                CssPinner(document.querySelector('.EventDetailContainer .panel-body'), false);
              }
            }}
          />
        </div>
      )
    },
    {
      selector: 'codes',
      name: 'Discount Code',
      sortable: true,
      style: {
        minWidth: '200px',
        padding: '10px 16px'
      },
      cell: (row: {}): string =>  row.codes ? row.codes.join(', ') : ''
    },
    {
      selector: 'applies',
      name: 'Applies to',
      sortable: true,
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        overflow: 'visible'
      },
      cell: (row: {}): React.Element<'div'> => {
        const appliedTickets = row.applied_to_tickets;

        if (row.applied_to_all_tickets) {
          return 'All tickets';
        } else if (_.size(appliedTickets) > 1) {
          return (
            <span data-tip={appliedTickets.join(',<br/>')} style={{ color: 'blue' }}>
                {_.size(appliedTickets)} Tickets
            </span>
          );
        } else if (_.size(appliedTickets) === 1) {
          return (<span>{appliedTickets[0]}</span>);
        }
      }
    },
    {
      selector: 'amount',
      name: 'Discount value',
      sortable: true,
      cell: (row: {}): string | number => {
        // TODO edit currency.USD
        if (row.use_percentage) {
          return `${row.percentage}%`;
        }

        return `${currency[context.profileCurrent.currency]}${row.amount / 100}`;
      }
    },
    {
      selector: 'perchase',
      name: 'Use per purchase',
      sortable: true,
      cell: (row: {}): string => {
        if (row.is_enable_usage_per_checkout) {
          return row.usage_per_checkout;
        }

        return 'Unlimited';
      }
    },
    {
      selector: 'limitation_times',
      name: 'Usage limit',
      sortable: true,
      cell: (row: {}): string => {
        if (row.is_enable_limitation_times) {
          return row.limitation_times;
        }

        return 'Unlimited';
      }
    },
    {
      selector: 'redeemed',
      name: 'Redeemed',
      sortable: true
    },
    {
      selector: 'begin_time_utc',
      name: 'Start time',
      sortable: true,
      cell: (row: {}): string => {
        if (!row.begin_time_utc) {
          return '-';
        }

        let date = moment(row.begin_time_utc);

        if (date.isValid()) {
          date = !row.begin_time_utc.toString().includes('Z') ? `${row.begin_time_utc}Z` : row.begin_time_utc;
          return convertToLocalTime(date, EventDetailContext.eventDetail.time_zone_id, 'MM-DD-YYYY hh:mm a z');
        }

        return '-';
      }
    },
    {
      selector: 'end_time_utc',
      name: 'Expiration time',
      sortable: true,
      cell: (row: {}): string => {
        if (!row.end_time_utc) {
          return '-';
        }

        let date = moment(row.end_time_utc);

        if (date.isValid()) {
          date = !row.end_time_utc.toString().includes('Z') ? `${row.end_time_utc}Z` : row.end_time_utc;
          return convertToLocalTime(date, EventDetailContext.eventDetail.time_zone_id, 'MM-DD-YYYY hh:mm a z');
        }

        return '-';
      }
    }
  ]);
};
